import Cookies from "js-cookie";

const mutations = {
  LOGIN(state, data) {
    window.console.log("LOGIN data", data);
    state.isLogin = true;
    state.userInfo = data;
    localStorage.setItem("accesstoken", data.accesstoken);
    localStorage.setItem("username", data.username);

  },
  LOGOUT(state) {
    state.isLogin = false;
    state.isAdmin = false;
    state.userInfo = "";
    state.branchInfo = null;
    localStorage.removeItem("accesstoken");
    localStorage.removeItem("username");
  },
  SET_NAVBAR(state, data) {
    state.navbarState = data;
  },
  SET_USER_INFO(state, data) {
    if (data.isAdmin) {
      state.isAdmin = data.isAdmin;
    }
    if (data.email) {
      state.userInfo.email = data.email;
    }

    if (data.type) {
      state.userInfo.type = data.type;
    }

    if (data.mobileNo) {
      state.userInfo.mobileNo = data.mobileNo;
    }

    if (data.username) {
      state.userInfo.username = data.username;
    }
    if (data.avatar) {
      state.userInfo.avatar = data.avatar;
    }
    if (data.id) {
      state.userInfo.id = data.id;
    }
    if (data.point) {
      state.userInfo.point = data.point;
    }
    if (data.serviceCode) {
      state.userInfo.serviceCode = data.serviceCode;
    }
  },
  langChange(state, data) {
    state.currentLang = data;
    Cookies.set("language", data);
  },
};
export default mutations;
